import { render, staticRenderFns } from "./APP.vue?vue&type=template&id=d35603a6&"
import script from "./APP.vue?vue&type=script&lang=js&"
export * from "./APP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports